<div class="container-fluid">
  <div class="row">
    <div class="col">
      <h2>Vendors Validated</h2>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <app-display-card-column [itemCollection]="CompanyVendors">
        <ng-template let-item="item" let-index="index">
          <div class="row">
            <div class="col">
              <div class="row">
                <div class="col-auto"><label>Legal Name:</label></div>
                <div class="col">
                  <label>{{ item.Vendor.legalName }}</label>
                </div>
              </div>
            </div>
            @if (item.Vendor.dba) {
              <div class="col">
                <div class="row">
                  <div class="col-auto"><label>DBA:</label></div>
                  <div class="col">
                    <label>{{ item.Vendor.dba }}</label>
                  </div>
                </div>
              </div>
            }
            <div class="col">
              <div class="row">
                <div class="col-auto"><label>VIVE Status:</label></div>
                <div class="col">
                  <label>{{ item.viveStatus }}</label>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row">
                <div class="col-auto"><label>Address:</label></div>
                <div class="col">
                  <label
                    >{{ item.Vendor.StreetAddress.address1 }}
                    {{ item.Vendor.StreetAddress.address2 || '' }}
                    {{ item.Vendor.StreetAddress.city }},
                    {{ item.Vendor.StreetAddress.state }}
                    {{ item.Vendor.StreetAddress.zip }}</label
                  >
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </app-display-card-column>
    </div>
  </div>
</div>
